import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { ModuloSistema } from '@/shared/constants/modulos-sistema.enum';
import { ToastContainer, toast } from 'react-toastify';
import { getTokenForAttendanceSheet } from '../../application/use-cases/get-token-for-attendance-sheet';
import { retrieveAttendanceSheetTokenInfo } from '../../application/use-cases/retrieve-attendance-sheet-token-info';
import { setLoginTokenOnStorage, SetPermissoes, } from '@/modules/system/auth/application/auth.service';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isValidCPF, validaCPF } from '@/shared/utils/cpfs';


export default function LoginComToken() {
  const context = useContext(MyContext);
  if (!context)
    throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const { state, setState } = context;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const cpfRef = useRef<HTMLInputElement>(null);
  const [modo, setModo] = useState<'token' | 'cpf'>('cpf');

  const [token, setToken] = useState('');
  const [cpf, setCpf] = useState('');
  const [isExecuting, setExecuting] = useState<boolean>();

  useEffect(() => {
    const tokenParam = searchParams.get('token')?.trim();
    const cpfParam = searchParams.get('cpf')?.trim();

    if (tokenParam) {
      setModo('token');
      setToken(tokenParam);
      if (tokenParam.length > 20) {
        logarComTokenUrl(tokenParam);
      }
    } else if (cpfParam) {
      setModo('cpf');
      setCpf(cpfParam);
      if (validaCPF(cpfParam)) {
        gerarTokenEnviarPorEmail(cpfParam);
      }
    } else {
      setModo('cpf');
    }
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setExecuting(true);
    try {
      if (modo === 'token') {
        const formToken = token.trim();
        if (!formToken || formToken.length <= 20) {
          toast.warn('Token inválido.');
          return;
        }
        await logarComTokenUrl(formToken);
      }

      if (modo === 'cpf' && cpf) {
        if (!isValidCPF(cpf)) {
          toast.warn('CPF inválido.');
          return;
        }
        await gerarTokenEnviarPorEmail(validaCPF(cpf.trim()));
      }
    } catch (error) {
      toast.error(String(error));
    } finally {
      setExecuting(false);
    }
  };

  const logarComTokenUrl = async (token: string) => {
    try {
      const response = await retrieveAttendanceSheetTokenInfo({ input: token });
      setState({
        ...state,
        username: undefined,
        nome: undefined,
        modulo: ModuloSistema.FolhaFrequencia,
        navbar: false,
        cpf: response.personCPF
      });
      SetPermissoes('');
      setLoginTokenOnStorage(token);

      if (response.folhaId)
        navigate(`${Links.Folha_Frequencia_Editar}/${response.folhaId}`);
      else navigate(`${Links.Folha_Frequencia_Index}`);
    } catch (error) {
      toast.error(String(error));
    }
  };

  const gerarTokenEnviarPorEmail = async (cpf: string) => {
    await getTokenForAttendanceSheet({ input: cpf })
      .then(() => {
        toast.info('Token enviado, voltando ao login.');
        setTimeout(() => navigate(Links.Veirifique_Email), 3000);
      })
      .catch((error) => {
        toast.error(String(error));
      });
  };

  return (
    <Fragment>
      <ToastContainer position="top-center" />
      <section className="ftco-section">
        <div className="loginrow w-100 justify-content-center">
          <div style={{ width: '35%', minWidth: '25%', maxWidth: '40%' }}>
            <form onSubmit={handleSubmit} className="signin-form">
              <h4 className="mb-4">
                {modo === 'token'
                  ? 'Informe o token de acesso'
                  : 'Obter token de acesso'}
              </h4>

              {modo === 'token' && (
                <div className="mb-4">
                  <label htmlFor="token" className="loginlabel">
                    Token:
                  </label>
                  <input
                    id="token"
                    name="token"
                    type="text"
                    className="form-control"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    required
                  />
                </div>
              )}

              {modo === 'cpf' && (
                <div className="mb-4">
                  <label htmlFor="cpf" className="loginlabel">
                    CPF:
                  </label>
                  <input
                    ref={cpfRef}
                    id="cpf"
                    name="cpf"
                    type="text"
                    className="form-control"
                    value={cpf}
                    onChange={(e) => {
                      setCpf(validaCPF(e.target.value, true));
                    }}
                    minLength={11}
                    maxLength={14}
                    required
                  />
                </div>
              )}

              <div className="text-center">
                <button
                  type="submit"
                  className="form-control loginbtn loginbtn-primary submit w-50"
                  disabled={isExecuting}
                  style={{
                    cursor: isExecuting ? 'not-allowed' : 'pointer',
                  }}
                >
                  {isExecuting
                    ? 'Aguarde...'
                    : modo === 'token'
                      ? 'Acessar'
                      : 'Obter Token'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Fragment>
  );
}
